<template>
  <div class="eps-info-app">
    <template v-if="isLoading">
      <EPSInfoSkeleton />
    </template>
    <template v-else>
      <EarningsCallsInfoList :list="earningsCallsInfoList" />
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue'

import {
  useGetEarningsCallData,
  useEarningsCallInfoData,
} from '@/modules/earnings_calls_preview/composables'
import EarningsCallsInfoList from '@/modules/earnings_calls_preview/components/EarningsCallsInfoList.vue'

import EPSInfoSkeleton from './components/EPSInfoSkeleton.vue'

const [,,,, earningsCallId] = window.location.pathname.split('/')

const {
  date,
  epsReported,
  epsEstimate,
  epsReportedLastYear,
  isLoading,
  getLatestEarningsCallData,
} = useGetEarningsCallData({
  earningsCallId: ref(earningsCallId),
})

getLatestEarningsCallData()

const {
  earningsCallsInfoList,
} = useEarningsCallInfoData({
  date,
  epsReported,
  epsEstimate,
  epsReportedLastYear,
})
</script>

<style scoped lang="scss">
.eps-info-app { }
</style>
